import classNames from "classnames";
import React, { CSSProperties, ReactNode } from "react";
import styles from "./Card.module.scss";

type Props = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
};

function Card({ children, onClick, className, style }: Props) {
  return (
    <div
      className={classNames(styles.card, className)}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}

export default Card;
